export default "__VITE_ASSET__Doyhw2tA__"